import { Separator } from '@talentmesh/ui/components/separator';
import { TypographyH4 } from '@talentmesh/ui/components/typography';
import StatusCounter from './components/StatusCounter';
import TestIncluded from './TestIncluded';
import UIStrings from '@/Utils/UIStrings';

interface RecruitmentInfoProps {
    hasPersonality: boolean;
    hasAptitude: boolean;
    hasSkills: boolean;
    hasEmotionalIntelligence: boolean;
    completedCount: number;
}

function AssessmentInfo({
    hasPersonality,
    hasAptitude,
    hasSkills,
    hasEmotionalIntelligence,
    completedCount,
}: RecruitmentInfoProps) {
    return (
        <div className="bg-muted flex min-h-36 flex-col items-center justify-between gap-1 rounded-xl px-2 pt-3">
            <TypographyH4 className="text-foreground">{UIStrings.Assessment}</TypographyH4>
            <Separator orientation="horizontal" className="w-full shrink-0" />
            <div className="flex h-full w-full flex-row items-stretch gap-1">
                <TestIncluded
                    hasPersonality={hasPersonality}
                    hasAptitude={hasAptitude}
                    hasSkills={hasSkills}
                    hasEmotionalIntelligence={hasEmotionalIntelligence}
                />
                <StatusCounter status={UIStrings.Completed} count={completedCount} />
            </div>
        </div>
    );
}

export default AssessmentInfo;
